import { RouteObject } from "react-router-dom";
import pathRoutes from "../../../routes/pathRoutes";
import Authenticated from "../../../utils/Authenticated";
import { MODES_OPTIONS } from "../../../types/generics.types";
import BackgroundListLayout from "../layouts/layout";
import BackgroundList from "../background";
import LayoutEditFondo from "../layouts/layoutEdit";
import EditBackgound from "../editBackground";
import { PrivateRoutes } from "@app/utils/PrivateRoutes";
import { RolesTypes } from "@app/pages/users/utils/helpers";

const routesReport: RouteObject = {
  path: pathRoutes.ADMIN_FONDOS,
  element: (
    <Authenticated>
      <BackgroundListLayout />
    </Authenticated>
  ),
  children: [
    {
      path: "",
      index: true,
      element: (
        <Authenticated>
          <BackgroundList />
        </Authenticated>
      ),
    },
    {
      path: "nuevo",
      element: (
        <PrivateRoutes permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}>
          <LayoutEditFondo />
        </PrivateRoutes>
      ),
      children: [
        {
          index: true,
          element: (
            <Authenticated>
              <EditBackgound mode={MODES_OPTIONS.NEW} />
            </Authenticated>
          ),
        },
      ],
    },
    {
      path: "editar/:idBackground",
      element: (
        <PrivateRoutes permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}>
          <LayoutEditFondo />
        </PrivateRoutes>
      ),
      children: [
        {
          index: true,
          element: (
            <Authenticated>
              <EditBackgound mode={MODES_OPTIONS.EDIT} />
            </Authenticated>
          ),
        },
      ],
    },
  ],
};

export default routesReport;
